/**
 * Anti-cannibalisation blog (audits GSC 2026-07-25 et 2026-08-01) : quand deux
 * articles se battent sur la même requête, le plus faible pointe canoniquement
 * vers le plus fort pour consolider le classement au lieu de le diluer.
 *
 * SOURCE UNIQUE partagée app + server (Nuxt `shared/`) :
 *  - app/pages/blog/[slug].vue : émet le <link rel=canonical> overridé ;
 *  - server sitemap/RSS/Atom : EXCLUENT ces slugs — une URL non canonique
 *    listée dans un sitemap est une erreur (« URL non canonique », audit
 *    SemRush 2026-08-05). Ajouter une entrée ici suffit à couvrir les deux.
 *
 * ─── HISTORIQUE ──────────────────────────────────────────────────────────
 * Audit 2026-08-06 : 17 « jumeaux » (articles régénérés avec un suffixe
 * d'année au lieu d'être mis à jour, et une famille « donoor-vs-<concurrent> »)
 * avaient été rattachés ici par canonical. L'inspection Search Console du
 * 2026-11-04 a montré que Google ignorait ce canonical (10 jumeaux indexés à
 * part, dont la tombola « 2026 » à 718 affichages en 90 jours ; sur
 * sponsoring/mécénat il classait même le jumeau, 684 affichages contre 11).
 * 14 d'entre eux sont donc REDIRIGÉS en 301 depuis le 2026-11-04
 * (shared/utils/pagesRegroupees.ts, ARTICLES_REGROUPES) — un canonical est un
 * conseil que Google peut refuser, la 301 non.
 *
 * Restent ici les cas où la 301 n'est pas sûre d'aider (ci-dessous).
 * ⚠️ Un canonical ne SUPPRIME rien : la page reste en ligne et lisible.
 */
export const BLOG_CANONICAL_OVERRIDES: Record<string, string> = {
  // QR code de don en mosquée : sujet voisin mais DIFFÉRENT de l'article
  // gardé (où placer les QR codes, formats, affiches, contre « borne ou QR
  // code ? »). Les fusionner ferait perdre ce guide ; on ne force rien.
  "qr-code-don-mosquee-2026":
    "https://donoor.org/blog/borne-don-mosquee-vs-qr-code",

  // « Donoor vs PayAsso / Yapla » : le comparateur généraliste ne détaille
  // pas ces deux plateformes (PayAsso n'y figure pas) — une 301 enverrait la
  // personne qui cherche « payasso » sur une page qui n'en parle pas.
  "donoor-vs-payasso-comparatif-2026": "https://donoor.org/comparateurs",
  "donoor-vs-yapla-comparatif-2026": "https://donoor.org/comparateurs",
};

/** Slugs à exclure de tout sitemap/flux (leur canonical pointe ailleurs). */
export const NON_CANONICAL_BLOG_SLUGS = new Set(
  Object.keys(BLOG_CANONICAL_OVERRIDES),
);
